import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// Import the AskSLAI button
import AskSLAI from '../components/AskSLAI'; // Adjust path if needed

const TopBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Map specific paths to their corresponding page titles.
    // Adjust or expand these mappings as needed.
    const routeTitles = {
        '/dashboard': 'Dashboard',
        '/campaigns': 'Campaigns',
        '/leads': 'Leads',
        '/agents': 'Agents',
        '/call-studio': 'Call Studio',
        '/smart-dialer': 'Smart Dialer',
        '/script-builder': 'Script Builder',
        '/sms-inbox': 'SMS Inbox',
        '/slai-training': 'SLAI Training Portal',
        '/reports': 'Reports',
        '/settings': 'Settings',
    };

    // Determine the title based on the current pathname.
    // If the pathname is not found in our mapping, default to "Dashboard".
    const pageTitle = routeTitles[location.pathname] || 'Dashboard';

    // Handle Logout
    const handleLogout = () => {
        localStorage.removeItem('token'); // Clear the token
        navigate('/login');              // Redirect to login
    };

    return (
        <header className="top-bar">
            <div className="top-bar__left">
                <h1>{pageTitle}</h1>
            </div>

            <div className="top-bar__right">
                {/* Search Bar is slightly offset left to make room for the new icon button */}
                <input
                    type="text"
                    placeholder="Search..."
                    className="search-bar"
                />

                {/* New: AskSLAI inline button (round icon) to the right of search */}
                <AskSLAI />

                <div className="top-bar__icons">
                    <button className="icon-button bell-icon">
                        <img src="/icons/notif.png" alt="Bell Icon" />
                    </button>
                    <button className="icon-button profile-icon">
                        <img src="/icons/profile.png" alt="Profile Icon" />
                    </button>

                    {/* New Logout Button */}
                    <button className="logout-btn" onClick={handleLogout}>
                        Logout
                    </button>
                </div>
            </div>
        </header>
    );
};

export default TopBar;
